import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaDownload, FaPlay, FaChevronDown, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { SEO } from '../../components/SEO';
import { FaCheckCircle, FaShoppingCart, FaTruck, FaFileInvoiceDollar, FaBoxOpen, FaClipboardList } from 'react-icons/fa';
import BrandText from '../../styles/brandStyles';

const AdministracionCompras = () => {
  const { translate } = useLanguage();
  const [activeSection, setActiveSection] = useState('overview');
  const [isSticky, setIsSticky] = useState(false);
  
  // Estados para controlar los carruseles
  const [activeCard1, setActiveCard1] = useState(0);
  const [activeCard2, setActiveCard2] = useState(0);
  const [activeCard3, setActiveCard3] = useState(0);

  // Datos para los carruseles
  const carouselData1 = [
    {
      image: "/images/modules/opus_m3/001 interface.png",
      title: "Interface amigable",
      description: "Accede a una interfaz intuitiva y fácil de usar que facilita la gestión de compras, con integración directa a otros módulos OPUS para un flujo de trabajo optimizado.",
      features: [
        "Interfaz intuitiva",
        "Integración con M1",
        "Gestión simplificada de órdenes"
      ],
      link: "/caracteristicas/interface-compras"
    },
    {
      image: "/images/modules/opus_m3/002 comparativos a detalle.png",
      title: "Comunicación con proveedores",
      description: "Genera comparativos detallados para evaluar cotizaciones y facilitar la comunicación con proveedores, asegurando la selección de las mejores opciones de compra.",
      features: [
        "Exportación a Excel para proveedores",
        "No requiere que proveedores usen OPUS",
        "Comunicación eficiente"
      ],
      link: "/caracteristicas/comunicacion-proveedores"
    },
    {
      image: "/images/modules/opus_m3/003 Catálogo inteligente de unidades.png",
      title: "Comparativos a detalle",
      description: "Implementa un catálogo inteligente de unidades que facilita la conversión automática y optimiza el proceso de compra, reduciendo errores y desperdicios.",
      features: [
        "Comparación de múltiples proveedores",
        "Análisis de condiciones comerciales",
        "Identificación de mejores ofertas"
      ],
      link: "/caracteristicas/comparativos-compras"
    }
  ];

  const carouselData2 = [
    {
      image: "/images/modules/opus_m3/004 Poderoso reporteador.png",
      title: "Catálogo inteligente de unidades",
      description: "Accede a un reporteador poderoso y flexible que permite generar informes personalizados de requisiciones, órdenes de compra, entregas y análisis de proveedores.",
      features: [
        "Conversión automática de unidades",
        "Optimización de adquisiciones",
        "Reducción de desperdicios"
      ],
      link: "/caracteristicas/unidades-compra"
    },
    {
      image: "/images/modules/opus_m3/005 documentos de intercambio.png",
      title: "Poderoso reporteador",
      description: "Gestiona el intercambio de documentos relacionados con el proceso de compra, incluyendo entregas, devoluciones, facturas y pagos para un seguimiento completo.",
      features: [
        "Reportes personalizables",
        "Seguimiento de estatus",
        "Análisis de desempeño de proveedores"
      ],
      link: "/caracteristicas/reportes-compras"
    },
    {
      image: "/images/modules/opus_m3/001 interface.png",
      title: "Documentos de intercambio",
      description: "Utiliza una interfaz amigable para gestionar documentos de intercambio con proveedores, facilitando el control y seguimiento de toda la documentación del ciclo de compra.",
      features: [
        "Gestión documental integrada",
        "Seguimiento de entregas y pagos",
        "Control administrativo completo"
      ],
      link: "/caracteristicas/documentacion-compras"
    }
  ];

  const carouselData3 = [
    {
      image: "/images/modules/opus_m3/002 comparativos a detalle.png",
      title: "Control de almacén",
      description: "Utiliza comparativos detallados para optimizar la gestión de almacén, controlando entradas, salidas, traspasos y el nivel de existencias en tiempo real.",
      features: [
        "Gestión de inventario en tiempo real",
        "Múltiples almacenes",
        "Control de existencias"
      ],
      link: "/caracteristicas/almacen"
    },
    {
      image: "/images/modules/opus_m3/003 Catálogo inteligente de unidades.png",
      title: "Integración con módulos OPUS",
      description: "Aprovecha el catálogo inteligente de unidades para facilitar la integración con otros módulos OPUS, asegurando consistencia en la información entre presupuestos y compras.",
      features: [
        "Vinculación con presupuesto y programación",
        "Actualización automática entre módulos",
        "Sistema integral"
      ],
      link: "/caracteristicas/integracion-modulos"
    },
    {
      image: "/images/modules/opus_m3/004 Poderoso reporteador.png",
      title: "Trazabilidad completa",
      description: "Utiliza el poderoso reporteador para dar seguimiento detallado a todo el ciclo de compra, desde la requisición hasta la entrega y pago, con trazabilidad completa.",
      features: [
        "Seguimiento de ciclo completo",
        "Historial de transacciones",
        "Auditoría de procesos"
      ],
      link: "/caracteristicas/trazabilidad"
    }
  ];

  // Función para manejar el scroll y actualizar la sección activa
  useEffect(() => {
    const handleScroll = () => {
      // Detectar si el submenú debe ser sticky
      const heroSection = document.getElementById('overview');
      const headerHeight = 64; // Altura del header principal
      
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsSticky(heroBottom <= headerHeight);
      } else {
        // Si no se encuentra la sección, mantener el menú sticky para evitar que desaparezca
        setIsSticky(true);
      }

      // Detectar qué sección está visible
      const sections = ['overview', 'features', 'capabilities', 'benefits', 'cta'];
      let activeFound = false;
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offset = 140; // Altura del header + submenu
          if (rect.top <= offset && rect.bottom >= offset) {
            setActiveSection(section);
            activeFound = true;
            break;
          }
        }
      }
      
      // Si no se encuentra ninguna sección activa, mantener la última activa
      if (!activeFound && window.scrollY > 0) {
        // Mantener la sección activa anterior o establecer una por defecto
        setIsSticky(true);
      }
    };

    // Ejecutar handleScroll inmediatamente para establecer el estado inicial
    handleScroll();
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Función para hacer scroll a una sección
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 140; // Altura del header + submenu
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Funciones para navegar entre las tarjetas
  const nextCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard + 1) % maxCards);
  };

  const prevCard = (setActiveCard, activeCard, maxCards) => {
    setActiveCard((activeCard - 1 + maxCards) % maxCards);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="OPUS - Módulo 3: Administración de Compras | ECOSOFT"
        description="Gestione eficientemente todo el ciclo de compras, proveedores y suministros con el módulo de Administración de Compras de OPUS."
        keywords="OPUS, compras, adquisiciones, proveedores, suministros, almacén, ingeniería de costos"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[450px] bg-gradient-to-r from-[#003171] to-[#0066CC]" style={{
        backgroundImage: 'url("/images/modules/opus_m3/cabecera_m3.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <div className="flex items-center mb-6">
              <div className="relative w-32 h-32 mr-6 flex-shrink-0">
                <div className="absolute inset-[5%] bg-white rounded-full"></div>
                <img 
                  src="/images/m3.svg" 
                  alt="Módulo 3" 
                  className="w-full h-full relative z-10"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h1 className="text-5xl font-bold">OPUS M3</h1>
                <h2 className="text-4xl font-bold mt-2">Administración de Compras</h2>
              </div>
            </div>
            <p className="text-xl mb-8">
              Control de adquisiciones, almacenes e inventarios para optimizar la gestión de recursos materiales.
            </p>
            <div className="flex gap-4">
              <Link to="/soporte/descargas" className="bg-white text-[#0066CC] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors">
                Descargar
              </Link>
              <Link to="/Distribuidores" className="border-2 border-white text-white px-8 py-3 rounded-md font-semibold hover:bg-white/10 transition-colors">
                Ver demostración
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Submenu Navigation */}
      <div 
        className={`bg-white shadow-md transition-all duration-300 sticky-nav ${
          isSticky 
            ? 'fixed top-[64px] left-0 right-0 z-30 border-t border-gray-200' 
            : 'relative'
        }`}
        style={{ minHeight: '56px' }} // Altura mínima para evitar saltos
      >
        <div className="container mx-auto px-4 max-w-7xl\">
          <div className="flex overflow-x-auto py-4 items-center relative">
            <div className="flex-grow flex">
              <button 
                onClick={() => scrollToSection('overview')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'overview' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Resumen
              </button>
              <button 
                onClick={() => scrollToSection('features')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'features' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Características
              </button>
              <button 
                onClick={() => scrollToSection('capabilities')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'capabilities' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Capacidades
              </button>
              <button 
                onClick={() => scrollToSection('benefits')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'benefits' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Beneficios
              </button>
              <button 
                onClick={() => scrollToSection('cta')}
                className={`px-6 py-2 whitespace-nowrap font-medium ${
                  activeSection === 'cta' 
                    ? 'text-[#0066CC] border-b-2 border-[#0066CC]' 
                    : 'text-gray-600 hover:text-[#0066CC]'
                }`}
              >
                Comenzar
              </button>
            </div>
            <div className="flex items-center ml-4">
              <img 
                src="/images/m3.svg" 
                alt="Módulo 3 - Administración de Compras" 
                className="h-12 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Features Section */}
      <section id="features" className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Características principales</h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaShoppingCart className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Gestión de adquisiciones</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Requisiciones integradas con el presupuesto</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Solicitud y comparativo de cotizaciones</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Órdenes de compra y contratos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Asignación automática a partidas presupuestales</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Aprobaciones multinivel</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaTruck className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Control de almacén</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Recepción de materiales y equipos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Gestión de múltiples almacenes</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Control de existencias en tiempo real</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Entradas y salidas de materiales</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Vales y control de inventarios</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaFileInvoiceDollar className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Cuentas por pagar</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Registro y validación de facturas</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Programación de pagos a proveedores</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Seguimiento de cuentas por pagar</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Antigüedad de saldos</span>
                </li>
                <li className="flex items-start">
                  <FaCheckCircle className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                  <span>Conciliación con contabilidad</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section id="capabilities" className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-3">Lo que puedes hacer con OPUS M3</h2>
          <p className="text-xl text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            Descubre cómo OPUS M3 te ayuda a gestionar todo el ciclo de compras y almacén de manera eficiente.
          </p>
          
          <div className="space-y-12">
            {/* Capability 1 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData1[activeCard1].image} 
                  alt={carouselData1[activeCard1].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard1, activeCard1, carouselData1.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData1[activeCard1].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData1[activeCard1].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData1[activeCard1].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 2 */}
            <div className="flex flex-col md:flex-row-reverse gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData2[activeCard2].image} 
                  alt={carouselData2[activeCard2].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard2, activeCard2, carouselData2.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData2[activeCard2].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData2[activeCard2].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData2[activeCard2].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Capability 3 */}
            <div className="flex flex-col md:flex-row gap-6 items-center">
              <div className="w-full md:w-1/2 relative group">
                <img 
                  src={carouselData3[activeCard3].image} 
                  alt={carouselData3[activeCard3].title} 
                  className="rounded-lg shadow-lg w-full h-72 object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button 
                    onClick={() => prevCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Anterior"
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button 
                    onClick={() => nextCard(setActiveCard3, activeCard3, carouselData3.length)}
                    className="bg-white/90 hover:bg-white text-[#0066CC] p-3 rounded-full shadow-lg transition-colors"
                    aria-label="Siguiente"
                  >
                    <FaChevronRight size={20} />
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="text-2xl font-bold mb-3 text-[#1A2B39]">{carouselData3[activeCard3].title}</h3>
                <p className="text-gray-600 mb-4">{carouselData3[activeCard3].description}</p>
                <ul className="space-y-2 mb-6">
                  {carouselData3[activeCard3].features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-[#0066CC] mt-1 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section id="benefits" className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#1A2B39]">Beneficios clave</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaShoppingCart className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Reducción de costos</h3>
              <p className="text-gray-600">
                Optimiza el proceso de compras, obtén mejores precios y reduce inventarios innecesarios.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaBoxOpen className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Control de inventarios</h3>
              <p className="text-gray-600">
                Mantén niveles óptimos de inventario, evita faltantes y reduce el capital inmovilizado.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaClipboardList className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Procesos eficientes</h3>
              <p className="text-gray-600">
                Automatiza el ciclo completo de compras desde la requisición hasta el pago a proveedores.
              </p>
            </div>
            
            <div className="bg-[#F5F7FA] p-6 rounded-lg">
              <FaFileInvoiceDollar className="text-[#0066CC] text-4xl mb-4" />
              <h3 className="text-xl font-bold mb-3 text-[#1A2B39]">Control financiero</h3>
              <p className="text-gray-600">
                Mejora la visibilidad de compromisos financieros y optimiza el flujo de caja.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Integration with other modules */}
      <section className="py-16 bg-[#F5F7FA]">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Integración con otros módulos</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            El Módulo 3 se integra perfectamente con el resto de OPUS para ofrecer una solución completa
          </p>
          
          <div className="grid md:grid-cols-5 gap-6 max-w-5xl mx-auto">
            <Link to="/modulos/presupuesto-programable" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 1</h3>
              <p className="text-gray-600 text-sm">Presupuesto Programable</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/planeacion-control" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 2</h3>
              <p className="text-gray-600 text-sm">Planeación y Control</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/administracion-compras" className="bg-[#F5F7FA] p-5 rounded-lg text-center border-2 border-[#0066CC] hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 3</h3>
              <p className="text-gray-600 text-sm">Administración de Compras</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/dependencias" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 4</h3>
              <p className="text-gray-600 text-sm">Dependencias</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
            
            <Link to="/modulos/cuantificacion-bim" className="bg-[#F5F7FA] p-5 rounded-lg text-center hover:bg-[#0066CC]/5 transition-colors">
              <h3 className="text-lg font-bold mb-2 text-[#1A2B39]">Módulo 5</h3>
              <p className="text-gray-600 text-sm">Cuantificación BIM</p>
              <div className="mt-3 h-1 w-full bg-[#0066CC] rounded"></div>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Cursos y CERTIFICADOS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl\">
          <h2 className="text-3xl font-bold text-center mb-8 text-[#1A2B39]">Cursos y Certificados</h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Fortalece tus conocimientos en OPUS Administración de Compras con nuestro programa de certificación
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaShoppingCart className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso básico</h3>
              <p className="text-gray-600 mb-4 text-center">
                Aprende los fundamentos para administrar eficientemente compras y suministros
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaBoxOpen className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Curso avanzado</h3>
              <p className="text-gray-600 mb-4 text-center">
                Domina técnicas avanzadas de administración y control de compras
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="w-16 h-16 bg-[#0066CC]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaFileInvoiceDollar className="text-[#0066CC] text-2xl" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-center">Certificación oficial</h3>
              <p className="text-gray-600 mb-4 text-center">
                Obtén la certificación oficial ECOSOFT que valida tus conocimientos profesionales
              </p>
              <Link 
                to="/certificaciones" 
                className="block text-center px-6 py-2 bg-[#0066CC] text-white rounded-md hover:bg-[#0055AA] transition-colors mx-auto w-full"
              >
                Ver detalles
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section id="cta" className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Listo para optimizar sus compras y adquisiciones?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Descubre todo el potencial de OPUS M3 Administración de Compras para controlar eficientemente tus adquisiciones.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/soporte/descargas" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Descargar
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Solicitar demostración
            </Link>
            <Link 
              to="/Distribuidores" 
              className="px-8 py-3 bg-white text-[#1A2B39] hover:bg-gray-100 font-medium rounded-md transition-colors"
            >
              Contactar con ventas
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdministracionCompras;
